// extracted by mini-css-extract-plugin
module.exports = {"alertDailog":"aoyWVsnsTfpHHh7qNiZbVw==","leftAlertDailog":"FNw3ee83S+YehOkjGwc1dg==","alertMessage":"_0NQ+UvzIBhAbTaSeJSW82w==","RegularButton":"wY4z4FR3rjTOuLOsK3Cjtg=="};